export interface Customer {
    countryCode: string;
    customerCode: string;
    customerDesc: string;
    customerId: number;
    legalEntityType?: LegalEntityType;
    links?: LegalEntityLinks;
    address?: Address;
}

export interface LegalEntityType {
    legalEntityId: number;
    legalEntityTypeId: number;
    legalEntityTypeCode: string;
    links: LegalEntityLinks;
}

export interface LegalEntityLinks {
    self: string;
    customersalesareas?: string;
    customerSegmentation?: string;
}

export interface Address {
    addressId: number;
    links: LegalEntityLinks;
}

export interface Company {
    companyCode: string;
    companyDesc: string;
    countryCode: string;
    divisionCode: number;
    paymentAllowed?: number;
}

export interface Jobsite {
    jobSiteCode: string;
    jobSiteDesc: string;
    jobSiteId: number;
    active?: boolean;
}

export interface Payer {
    payerCode?: string;
    payerDesc?: string;
}

interface ResponseLegalEntity {
    customer?: Array<Customer>;
    company?: Array<Company>;
    jobSite?: Array<Jobsite>;
    payer?: Array<Payer>;
}

export interface LegalEntityDTO {
    responseLegalEntity: ResponseLegalEntity;
}

export interface ResponseMyLegalEntities {
    links: LegalEntityLinks;
    count: number;
    totalCount: number;
    legalEntities: ResponseLegalEntityS1[];
}

export interface ResponseLegalEntityS1 {
    legalEntityId: number;
    countryCode: string;
    legalEntityTypeCode: string;
    legalEntityDesc: string;
    legalEntityType: LegalEntityType;
    links: LegalEntityLinks;
    address: Address;
}

export interface LegalEntityType {
    legalEntityId: number;
    legalEntityTypeId: number;
    legalEntityTypeCode: string;
    links: LegalEntityLinks;
}

export interface LegalEntityLinks {
    self: string;
    customersalesareas?: string;
    customerSegmentation?: string;
}

export interface Address {
    addressId: number;
    links: LegalEntityLinks;
}

export interface ResponseJobSitePayers {
  count: number;
  jobSitePayers: Jobsite[];
}
